import { render, staticRenderFns } from "./ProviderForm.vue?vue&type=template&id=38f123cb&"
import script from "./ProviderForm.vue?vue&type=script&lang=js&"
export * from "./ProviderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports